import { Component, Input } from '@angular/core'

@Component({
  selector: 'vmf-settlement-date',
  templateUrl: './settlement-date.component.html',
  styleUrls: ['./settlement-date.component.scss'],
})
export class SettlementDateComponent {
  @Input() performanceModel: any
}
